import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class MovementRequestFileModel extends Model implements IModel<MovementRequestFileModel> {
  movementRequestId: string = "";
  fileName: string = "";
  storageKey: string = "";
  contentType: string = "";
  fileSize: number = 0;
  generatedAt: Date | string = "";
  documentMockupId: string = "";

  static create(input: any): MovementRequestFileModel {
    if (input?.generatedAt) {
      input = {
        ...input,
        generatedAt: new Date(input.generatedAt),
      };
    }

    return ObjectMapper.deserialize<MovementRequestFileModel>(MovementRequestFileModel, input);
  }
}
